import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAILER_HOME = {
  nickname: 'PRODUCTS.TRAILER_HOME.nickname',
  properties: [
    { name: 'vehicleLicenceNumberAvailability', key: 'VEHICLE_LICENCE_NUMBER_AVAILABILITY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isLicenceNumberAvailabilityCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    {
      name: 'trailerHomeMark', key: 'WTC_MARK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    {
      name: 'trailerHomeModel', key: 'WTC_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'trailerMarketValue', key: 'MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'fieldsOfUse', key: 'FIELDS_OF_USE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.FIELDS_OF_USE.FIXED_SPACE', value: 'FIXED_SPACE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.FIELDS_OF_USE.DRIVEN_IN_TRAFFIC', value: 'DRIVEN_IN_TRAFFIC' }
        ]
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.50', value: 50000 },
        ]
      }
    },
    { name: 'zipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        TRAILER: {
          key: 'OBJECT_ZIP_INVALID'
        }
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    {
      name: 'wtcTrailerHomeExtraValuables', key: 'WTC_EXTRA_VALUABLES', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.0', value: 0 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.40', value: 40000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.50', value: 50000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.75', value: 75000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_EXTRA_VALUABLES.100', value: 100000 }
        ]
      }
    },
  ],
  icon:'trailer-home'
};
